/** A `datetime-local` input's local time as the UTC instant a Date and time filter holds. */
export function localInputToIso(local: string): string {
  const date = new Date(local);
  return local && !Number.isNaN(date.getTime()) ? date.toISOString() : local;
}
/** A Date and time filter's UTC instant as a `datetime-local` input's local time. */
export function isoToLocalInput(iso: string): string {
  const date = new Date(iso);
  if (!iso || Number.isNaN(date.getTime())) return iso;
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
